export default {
  shipping: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Order', value: 'orderName' },
      { label: 'Description', value: 'orderId' },
      { label: 'Hide Field', value: 'hide' },
    ],
    options: [
      {
        label: 'Project', //----------Prod order
        value: 'projectName',
      },
      {
        label: 'Project ID',
        value: 'projectId',
      },
      {
        label: 'Order',
        value: 'orderName',
      },
      {
        label: 'Description',
        value: 'orderId',
      },
      {
        label: 'Onsite By',
        value: 'deliverBy',
      },{
        label: 'Hide Field',
        value: 'hide',
      }, {
        label: 'Lot/Batch',
        value: 'batchId',
      }, {
        label: 'Activity',
        value: 'activity',
      },
    ],
  },
  item: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Item', value: 'itemName' },
      { label: 'Item ID', value: 'itemId' },
    ],
    options: [
      {
        label: 'Project',  //-------------Prod item label
        value: 'projectName',
      }, {
        label: 'Project ID',
        value: 'projectId',
      }, {
        label: 'Item',
        value: 'itemName',
      }, {
        label: 'Item ID',
        value: 'itemId',
      }, {
        label: 'Order',
        value: 'orderName',
      }, {
        label: 'Description',
        value: 'orderId',
      },{
        label: 'Install Loc',
        value: 'installLocs',
      }, {
        label: 'Item Notes',
        value: 'itemNotes',
      },
      {
        label: 'Hide Field',
        value: 'hide',
      },
       {
        label: 'Cost Code',
        value: 'itemCostCode',
      },
    ],
  },
  partial: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Order', value: 'orderName' },
    ],
    options: [
      {
        label: 'Project', //----shipping
        value: 'projectName',
      }, {
        label: 'Order',
        value: 'orderName',
      }, {
        label: 'Destination',
        value: 'deliveryLocation',
      }, {
        label: 'Origin',
        value: 'currentLocation',
      }, {
        label: 'Recipient',
        value: 'recipient',
      }, {
        label: 'Ship Date',
        value: 'deliveryStart',
      }, {
        label: 'Project ID',
        value: 'projectId',
      }, {
        label: 'Onsite By',
        value: 'deliverBy',
      },
      //  {
      //   label: '# Items',
      //   value: 'itemCount',
      // }, 
      {
        label: 'Hide Field',
        value: 'hide',
      },
    ],
  },
  serial: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Order', value: 'orderName' },
      { label: 'Item', value: 'itemName' },
      { label: 'Item ID', value: 'itemId' },
    ],
    options: [
      {
        label: 'Project',
        value: 'projectName',
      }, {
        label: 'Project ID',
        value: 'projectId',
      }, {
        label: 'Item',
        value: 'itemName',
      }, {
        label: 'Item ID',
        value: 'itemId',
      }, {
        label: 'Order',
        value: 'orderName',
      }, {
        label: 'Description',
        value: 'orderId',
      }, {
        label: 'Install Loc',
        value: 'installLocs',
      }, {
        label: 'Hide Field',
        value: 'hide',
      },
    ],
  },
  material: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Order', value: 'orderName' },
      { label: 'Submittal', value: 'submittal' },
    ],
    options: [
      {
        label: 'Project',
        value: 'projectName',
      }, {
        label: 'Project ID',
        value: 'projectId',
      }, {
        label: 'Order',
        value: 'orderName',
      }, {
        label: 'Submittal',
        value: 'submittal',
      }, {
        label: 'PO #',
        value: 'poNumber',
      }, {
        label: 'Description',
        value: 'orderId',
      }, {
        label: 'Order By',
        value: 'orderBy',
      }, {
        label: 'Ship By',
        value: 'shipBy',
      }, {
        label: 'Onsite By',
        value: 'onSite',
      }, {
        label: 'Hide Field',
        value: 'hide',
      }, 
    ],
  },
  materialItems: {
    default: [
      { label: 'Project', value: 'projectName' },
      { label: 'Project ID', value: 'projectId' },
      { label: 'Item', value: 'itemName' },
      { label: 'Item ID', value: 'itemId' },
      { label: 'Submittal', value: 'submittal' },
    ],
    options: [
      {
        label: 'Project',
        value: 'projectName',
      }, {
        label: 'Project ID',
        value: 'projectId',
      }, {
        label: 'Item',
        value: 'itemName',
      }, {
        label: 'Item ID',
        value: 'itemId',
      }, {
        label: 'Order',
        value: 'orderName',
      }, {
        label: 'Description',
        value: 'orderId',
      }, {
        label: 'Catalog Id',
        value: 'catId',
      }, {
        label: 'Submittal',
        value: 'submittal',
      }, {
        label: 'PO #',
        value: 'poNumber',
      }, {
        label: 'Order By',
        value: 'orderBy',
      }, {
        label: 'Ship By',
        value: 'shipBy',
      }, {
        label: 'Onsite By',
        value: 'onSite',
      }, {
        label: 'Install Loc',
        value: 'installLocs',
      }, {
        label: 'Hide Field',
        value: 'hide',
      },
    ],
  },
  inventoryItem: {
    default: [
      { label: 'Item', value: 'itemName' },
      { label: 'Item ID', value: 'itemId' },
      { label: 'Catalog Id', value: 'catId' },
    ],
    options: [
      {
        label: 'Item',
        value: 'itemName',
      }, {
        label: 'Item ID',
        value: 'itemId',
      }, {
        label: 'Catalog Id',
        value: 'catId',
      }, {
        label: 'Hide Field',
        value: 'hide',
      },
    ],
  },
};
